import type { ReactNode } from 'react';
import { Navigate } from 'react-router-dom';

import { RouteFallback } from '../../components/layout/RouteFallback';
import { usePlatformUi } from '../platform/platform-api';

/** Blocks the rating screen when SuperAdministrator hid it from the player menu. */
export function RequireRatingInMenu({ children }: { children: ReactNode }) {
  const ui = usePlatformUi();

  if (ui.isPending) return <RouteFallback />;
  if (!ui.data?.showRatingInMenu) return <Navigate to="/rounds" replace />;
  return children;
}
